import { render, staticRenderFns } from "./PizzaProponente.vue?vue&type=template&id=1e6372a3&"
import script from "./PizzaProponente.vue?vue&type=script&lang=js&"
export * from "./PizzaProponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports